/** Textes « journal » — le français fait foi. */
export const journal = {
  actions: {
    creer: 'Création', modifier: 'Modification', annuler: 'Annulation', deroger: 'Dérogation',
    cloturer: 'Clôture', change: 'Change', restituer_caution: 'Restitution de caution',
    resilier: 'Résiliation', faire_depart: 'Départ du véhicule', faire_retour: 'Retour du véhicule',
    demander_correction: 'Demande de correction', accorder_correction: 'Correction accordée',
    refuser_correction: 'Correction refusée', signaler: 'Anomalie signalée',
    mettre_liste_noire: 'Mise en liste noire', retirer_liste_noire: 'Retrait de la liste noire',
    supprimer: 'Suppression',
  } as Record<string, string>,
  /** Seules les entités dont le nom technique ne se lit pas ont un libellé. */
  entites: { Reservation: 'Réservation' } as Record<string, string>,
  titre: "Journal d'activité",
  sousTitre: (n: number) => `${n} entrées · qui a fait quoi, et ce qui a changé`,
  exporter: 'Exporter en CSV',
  fichier: 'journal-activite.csv',
  inalterable: 'Le journal est inaltérable : aucune entrée ne peut être modifiée ni supprimée, par personne.',
  toutesEntites: 'Toutes les entités',
  entrees: 'Entrées',
  aucune: 'Aucune entrée',
  col: { horodatage: 'Horodatage', utilisateur: 'Utilisateur', action: 'Action', entite: 'Entité', passe: "Ce qui s'est passé" },
  motif: (m: string) => `motif : ${m}`,
  avant: 'Avant',
  apres: 'Après',
  appareil: (a: string) => `Appareil : ${a}`,
  precedent: 'Précédent',
  suivant: 'Suivant',
  page: (p: number, n: number) => `page ${p} / ${n}`,
};
